import React from 'react';
import { useSelector } from 'react-redux';
import { formatDollars } from '../../../../../common';
import CardComponent from '../../../../../common/components/CardComponent';
import { RootState } from '../../../../../reducers';
import { theme } from '../../../../../themes';

interface Props {
  isLoading: boolean;
  hasErrors: boolean;
}

const CostBaseCard = (props: Props): JSX.Element => {
  const { isLoading, hasErrors } = props;
  const value = useSelector((state: RootState) => state.clients.client.gainsAndLosses?.results?.costBase);

  return <CardComponent progress={{ isLoading, hasErrors }} background={theme.palette.gradient2?.main} value={formatDollars(value)} subText={'COST BASE'} />;
};

export default CostBaseCard;
